import { NoteStateMap } from 'src/common/store/notebook/NotebookState';
import { defaultResultSettings } from 'src/common/store/notebook/NoteState';
import { ReduxState } from 'src/types';

export const resetNoteResults = (state: ReduxState) => ({
  ...state,
  notebook: {
    ...state.notebook,
    notes: Object.keys(state.notebook.notes)
      .map((key) => ({
        key,

        value: {
          ...state.notebook.notes[key],
          editorSettings: {
            ...state.notebook.notes[key].editorSettings,
            isStoreQueryPopoverOpen: false,
            isQueryConfigPopoverOpen: false,
            isSchemaDialogOpen: false,
          },
          resultSettings: defaultResultSettings,
          voiceboxSettings: {
            ...state.notebook.notes[key].voiceboxSettings,
            isOpen: false,
            pending: undefined,
          },
        },
      }))
      .reduce(
        (acc, { key, value }) => ({ ...acc, [key]: value }),
        {}
      ) as NoteStateMap,
  },
});
